import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PARTNER_THEME, FETCH_MASTER_URL_ENCRYPT, FETCH_MASTER_URL, PARTNER_THEME_URL } from '../config/app-settings.config';
import { EncrDecrService } from './encr-decr-service.service';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  themeParam: any;
  themeObj: any;
  partnerDcr: any;
  retrieveMob: any;
  trackMob: any;
  partnerDetails: any;
  partnerCode: any;
  partnerExpiryDate: any;
  tokenVal = window['authenticationDetails']['EapplyTokenGenerationResponse']['tokenGenerationResponse']['access_token'] || sessionStorage.getItem('jwt');

  constructor(private http: HttpClient, private encryptDecService: EncrDecrService) { }

  setThemePage(themeobj) {
    this.setTheme(themeobj);
  }

  private setTheme(theme: {}) {
    Object.keys(theme).forEach(k =>
      document.documentElement.style.setProperty(`--${k}`, theme[k])
      // document.getElementById('spa-content').style.setProperty(`--${k}`, theme[k])
    );
  }

  // getThemeData(theme) {
  //   let reqObj = { "partnerCode": theme};
  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       // Authorization: "Bearer " + this.tokenVal,
  //       withCredentials: "true",
  //       "Content-Type": "application/json"
  //     })
  //   };
  //   return this.http.post(`${PARTNER_THEME}`, reqObj, httpOptions);
  // }

  getThemeData(theme) {
    let themeUrl = `${PARTNER_THEME_URL}${theme}_Theme.json`;
    return this.http.get(themeUrl);
  }

  fetchMatserData(requestBody) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + this.tokenVal,
        withCredentials: 'true',
        'Content-Type': 'application/json',
      })
    };

    requestBody = FETCH_MASTER_URL_ENCRYPT ? this.encryptDecService.set(requestBody) : requestBody;
    return this.http.post(`${FETCH_MASTER_URL}`, requestBody, httpOptions);
  }

}
